const GetAllComponents_query = `
    query{
      allComponents{
        componentId
        formId{
          formId
          name          
        }
        answerTypeId{
          answerTypeId
          name
        }
        componentTypeId{
          componentTypeId
          name
        }
        label
        mandatory
        caption
        tooltip
        order               
      }
    }
`;

const GetComponentsByFormId_query = `

  query($formUuid: String!){

    formComponents(formUuid: $formUuid) {
      componentId
      formId{
        formId
        name          
      }
      answerTypeId{
        answerTypeId
        name
      }
      componentTypeId{
        componentTypeId
        name
      }
      label
      mandatory
      caption
      tooltip
      order
    }
  }
`;

const GetFormComponentsAnswersByFormId_query = `
  query($formUuid: String!){
    formComponentAnswerList(formUuid: $formUuid)
    {
      formId
      formUuid
      name
      approved
      componentList {
        componentId
        answerTypeId {
          name
        }
        componentTypeId {
          name
        }
        label
        mandatory
        caption
        tooltip
        order
        answerList {
          answerId   
          componentId{
            componentId
          }       
          label
          value
          score
          order
          width
          height
          maxLength
        }  
      }
    }
  }
`;

const DeleteComponent_mutation = `
  mutation deleteComponent($componentId: Int!,) {
    deleteComponent(
      componentId: $componentId
    ) {
      component{
        componentId
      }
    }
  }
`;

module.exports = {
  GET_ALL_COMPONENTS_QUERY: GetAllComponents_query,
  GET_COMPONENTS_BY_FORM_ID_QUERY: GetComponentsByFormId_query,
  GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY: GetFormComponentsAnswersByFormId_query,
  DELETE_COMPONENT_MUTATION: DeleteComponent_mutation,
};
